// extracted by mini-css-extract-plugin
module.exports = {"badge":"lVI4aP0_"};